export default "__VITE_ASSET__BZJ4BEfM__"